<template>
  <div>
    <div class="regra-modal__secao">
      <div class="regra-modal__secao-titulo">Identificação</div>
      <label class="regra-modal__rotulo" for="regra-negocio-descricao">Descrição *</label>
      <input
        id="regra-negocio-descricao"
        class="form-control"
        maxlength="250"
        placeholder="Ex.: Limite de itens em promoção no B2B"
        v-model="item.descricao"
      />
      <small v-if="erros.descricao" class="regra-modal__campo-erro">{{ erros.descricao }}</small>
    </div>

    <div class="regra-modal__secao">
      <div class="regra-modal__secao-titulo">Vigência e situação</div>
      <CRow class="align-items-start">
        <CCol md="4" class="mb-3 mb-md-0">
          <label class="regra-modal__rotulo" for="regra-negocio-data-inicial">Início</label>
          <div class="regra-negocio-informacao__data">
            <input
              id="regra-negocio-data-inicial"
              class="form-control"
              type="date"
              :max="item.data_final || null"
              :value="item.data_inicial"
              @input="alterarData('data_inicial', $event.target.value)"
            />
            <CButton
              v-if="item.data_inicial"
              variant="outline"
              color="secondary"
              title="Limpar data de início"
              aria-label="Limpar data de início"
              @click="alterarData('data_inicial', null)"
            >
              <fa-icon icon="times" />
            </CButton>
          </div>
          <small v-if="!item.data_inicial" class="regra-modal__dica">A regra terá início imediato.</small>
        </CCol>
        <CCol md="4" class="mb-3 mb-md-0">
          <label class="regra-modal__rotulo" for="regra-negocio-data-final">Término</label>
          <div class="regra-negocio-informacao__data">
            <input
              id="regra-negocio-data-final"
              class="form-control"
              type="date"
              :min="item.data_inicial || null"
              :value="item.data_final"
              @input="alterarData('data_final', $event.target.value)"
            />
            <CButton
              v-if="item.data_final"
              variant="outline"
              color="secondary"
              title="Limpar data de término"
              aria-label="Limpar data de término"
              @click="alterarData('data_final', null)"
            >
              <fa-icon icon="times" />
            </CButton>
          </div>
          <small v-if="erros.data_final" class="regra-modal__campo-erro">{{ erros.data_final }}</small>
          <small v-else-if="!item.data_final" class="regra-modal__dica">A regra não terá prazo de término.</small>
        </CCol>
        <CCol md="4">
          <InterruptorCashback
            rotulo="Situação"
            texto-ligado="Ativa"
            texto-desligado="Inativa"
            ajuda="Regras inativas não são validadas nos pedidos, mesmo dentro da vigência."
            :value="!!item.ativo"
            @input="$set(item, 'ativo', $event)"
          />
        </CCol>
      </CRow>
    </div>

    <div class="regra-modal__secao">
      <div class="regra-modal__secao-titulo">Canais em que a regra é validada</div>
      <div class="regra-negocio-informacao__canais">
        <SelectableCard
          v-for="canal in canais"
          :key="canal.campo"
          :value="canal.campo"
          :label="canal.label"
          :description="canal.descricao"
          :image="canal.imagem"
          :selected="!!item[canal.campo]"
          @select="alternarCanal"
        />
      </div>
      <small class="regra-modal__dica">Selecione ao menos um canal para que a regra seja aplicada.</small>
    </div>
  </div>
</template>

<script>
import InterruptorCashback from "@/views/Cashback/ModalRegraCashback/components/InterruptorCashback.vue";
import SelectableCard from "@/views/Campanhas/components/CampanhasComerciais/shared/SelectableCard.vue";
import { CANAIS_REGRA_NEGOCIO } from "../../../constantes";

export default {
  name: "informacao",
  components: { InterruptorCashback, SelectableCard },

  props: {
    item: { type: Object, required: true },
    erros: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      canais: CANAIS_REGRA_NEGOCIO,
    };
  },

  methods: {
    alterarData(campo, valor) {
      this.$set(this.item, campo, valor || null);
    },

    alternarCanal(campo) {
      this.$set(this.item, campo, !this.item[campo]);
    },
  },
};
</script>

<style scoped src="@/components/regras/regra-modal.css"></style>

<style scoped>
.regra-negocio-informacao__data {
  display: flex;
  gap: 6px;
}

.regra-negocio-informacao__canais {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

@media (max-width: 767.98px) {
  .regra-negocio-informacao__canais {
    grid-template-columns: 1fr;
  }
}
</style>
